import { render, staticRenderFns } from "./TradeNav.vue?vue&type=template&id=5c2b16ec&scoped=true&"
import script from "./TradeNav.vue?vue&type=script&lang=js&"
export * from "./TradeNav.vue?vue&type=script&lang=js&"
import style0 from "./TradeNav.vue?vue&type=style&index=0&lang=scss&module=true&"
import style1 from "./TradeNav.vue?vue&type=style&index=1&id=5c2b16ec&scoped=true&lang=css&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "5c2b16ec",
  null
  
)

export default component.exports